// TaskForm.tsx
import React, {useEffect, useMemo, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import MikaSelect from "../../../components/BbrosSelect/mikaSelect.component";
import {SelectOption} from "../../../types/selectOption.type";
import {toFixedNumber} from "../../../utils/react";
import {EInputTextType, Input} from "../../../components/Input/Input";
import './taskForm.scss'
import {Button, EButtonType} from "../../../components/Button";
import {axiosCaller} from "../../../utils/apiCaller";
import {setButtonLoading, setLoading} from "../../../actions/generalActions";
import {toast} from "react-toastify";
import DifferentColoredPlus from "../../../assets/icons/differentColoredPlus.svg";
import HotkeyButton from "../../../components/HotkeyButton/HotkeyButton";
import {isMobile} from "../../../constants/constants";

interface Props {
    task?: any,
    setShowTaskModal?: any
    setSelectedTask?: any
    getUpdatedData?:any
}

const TaskForm = (props: Props) => {
    const intl = useIntl();
    const fm = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage });

    const [selectedTaskStatus, setSelectedTaskStatus] = useState<SelectOption>({} as SelectOption)
    const [updatedStartDate, setUpdatedStartDate] = useState<any>()
    const [updatedEndDate, setUpdatedEndDate] = useState<any>()
    const [comment, setComment] = useState<any>()
    const [title, setTitle] = useState<any>()
    const [buttonLoader, setButtonLoader] = useState(false)

    const taskStatuses = useMemo(() => [
        { label: fm('agreement.task.status.export', 'Export'), value: 1 },
        { label: fm('agreement.task.status.installation', 'Installation'), value: 2 },
        { label: fm('agreement.task.status.supplier', 'Supplier'), value: 3 },
        { label: fm('agreement.task.status.break', 'Break'), value: 4 },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [intl]);

    useEffect(()=>{
        console.log(props?.task,'props?.task')
        if(props?.task?.id){
            let newEndDate = new Date(props?.task?.end)
            console.log(newEndDate,'newEndDate')
            newEndDate.setDate(props?.task?.end.getDate() - 1);
            setTitle(props?.task?.title)
            setComment(props?.task?.extendedProps?.comment)
            setUpdatedStartDate(props?.task?.start)
            setUpdatedEndDate(newEndDate)

        }
    },[props?.task])

    function createTask(){
        setButtonLoader(true)
        let newEndDate = updatedEndDate.setDate(updatedEndDate.getDate() + 2);
        let newStartDate = updatedStartDate.setDate(updatedStartDate.getDate() + 1);


        let payload = {
            title: title,
            comment: comment,
            start: new Date(newStartDate),
            end: new Date(newEndDate),
            taskStatusId: selectedTaskStatus?.value
        }

        axiosCaller('POST', `task`, payload).then((response: any) => {
            props?.getUpdatedData()
            closeModal()
            setButtonLoader(false)
        })
    }

    function editTask(id){
        let newEndDate = updatedEndDate.setDate(updatedEndDate.getDate() + 2);
        let newStartDate = updatedStartDate.setDate(updatedStartDate.getDate() + 1);

        setButtonLoader(true)
        let payload = {
            title: title,
            comment: comment,
            start: new Date(newStartDate),
            end: new Date(newEndDate),
            taskStatusId: selectedTaskStatus?.value
        }

        axiosCaller('POST', `task/${id}`, payload).then((response: any) => {
            props?.getUpdatedData()
            closeModal()
            setButtonLoader(false)
        })
    }

    function deleteTask(id){
        axiosCaller('DELETE', `task/${id}`).then((response: any) => {
            props?.getUpdatedData()
            closeModal()
            setButtonLoader(false)
        })
    }

    function closeModal(){
        props?.setSelectedTask({})
        props?.setShowTaskModal(false)
    }

    return (
        <div className={'task-form'}>
            <HotkeyButton
                keyCode="Escape"
                modifiers={[]}
                isActive={false}
                onStateChange={(state) => {
                    if(state){
                        closeModal()
                    }
                }}
            >
                <img className={'x-sign'} src={DifferentColoredPlus} alt="" onClick={() => {
                    closeModal()
                }}/>
            </HotkeyButton>
            <Input
                name="title"
                label="label"
                id="titleInput"
                value={title || ''}
                onChange={(name, value) => setTitle(value)}
                defaultValue=''
                type="text"
                inputTextType={EInputTextType.SimpleInput}
            >
                    <span className="font-weight-bold">
                        <FormattedMessage id="agreement.task.title" defaultMessage="Title"/>
                    </span>
            </Input>

            <Input
                name="comments"
                label="label"
                id="commentsInput"
                value={comment || ''}
                onChange={(name, value) => setComment(value)}
                defaultValue=''
                type="textarea"
                inputTextType={EInputTextType.SimpleInput}
            >
                    <span className="font-weight-bold">
                        <FormattedMessage id="agreement.task.comment" defaultMessage="Comment"/>
                    </span>
            </Input>

            <MikaSelect
                options={taskStatuses}
                value={selectedTaskStatus || ''}
                setEntireOptionFunction={setSelectedTaskStatus}
                selectWrapperClassName=" w-100 heightFitContent m-b mb-bottom"
                placeholder={fm('agreement.task.selectStatus', 'Select status')}
            >
                <FormattedMessage id="agreement.task.taskStatus" defaultMessage="Task status"/>
            </MikaSelect>

            <div className={`w-100 ${isMobile ? '' :"d-flex"}`}>
                <Input
                    name="date"
                    value={ updatedStartDate ? new Date(updatedStartDate) : ''}
                    type="date"
                    onChange={(name, value) => setUpdatedStartDate(value)}
                    inputWrapperClass={`${isMobile ? 'w-100' : "w-50"} simple-date-input heightFitContent ${updatedStartDate ? " " : 'does-not-have-data'}`}>
                    <FormattedMessage id="agreement.task.dateStart" defaultMessage="Start date *"/>
                </Input>
                <Input
                    name="date"
                    value={ updatedEndDate ? new Date(updatedEndDate) : ''}
                    type="date"
                    onChange={(name, value) => setUpdatedEndDate(value)}
                    inputWrapperClass={`${isMobile ? 'w-100' : "w-50"} simple-date-input heightFitContent ${updatedEndDate ? " " : 'does-not-have-data'}`}>
                    <FormattedMessage id="agreement.task.dateEnd" defaultMessage="End date *"/>
                </Input>
            </div>


            {props?.task?.id ? <div className={'editViewButtons'}>

                <Button
                    isLoading={buttonLoader}
                    isDisabled={buttonLoader}
                    submit={true}
                    className="actionButton"
                    onClick={() => deleteTask(props?.task?.id)}
                    buttonType={EButtonType.GreyButton}>
                    <FormattedMessage id="common.action.delete" defaultMessage="Delete"/>
                </Button>
                <Button
                    isLoading={buttonLoader}
                    isDisabled={buttonLoader}
                    submit={true}
                    className="actionButton"
                    onClick={() => editTask(props?.task?.id)}
                    buttonType={EButtonType.GreyButton}>
                    <FormattedMessage id="agreement.task.edit" defaultMessage="Edit"/>
                </Button>
            </div> : <Button
                isLoading={buttonLoader}
                isDisabled={buttonLoader}
                submit={true}
                className="actionButton"
                onClick={() => createTask()}
                buttonType={EButtonType.GreyButton}>
                <FormattedMessage id="common.action.save" defaultMessage="Save"/>
            </Button>}
        </div>
    );
};

export default TaskForm;
